import {JSX} from 'react'
import {entries} from 'shared/collection'
import {P, match} from 'ts-pattern'

export const createEl = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attributes?: {class?: string; style?: string} & JSX.IntrinsicElements[K] & {
      [key: `data-${string}`]: string
    }
) => {
  const el = document.createElement(tag)
  entries(attributes ?? {}).forEach(([k, v]) =>
    match(v)
      .with(P.number, P.string, n => el.setAttribute(k, String(n)))
      .otherwise(() => {})
  )
  return el
}
